// utils/helpers.js

export const generateUniqueId = () => {
  return Math.floor(10000000 + Math.random() * 90000000); // Ensures an 8-digit number
};
